var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { key: "download", staticClass: "download-app" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "download-button", on: { click: _vm.openApp } },
          [_vm._v("打开")]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-introduce" }, [
      _c("div", { staticClass: "logo" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("div", { staticClass: "introduce" }, [
        _c("div", { staticClass: "app-name" }, [_vm._v("汇金智通")]),
        _vm._v(" "),
        _c("div", { staticClass: "introduce-words" }, [
          _vm._v("走近数字世界中的上市公司")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }